<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2021-03-03 10:49:23
 * @LastEditTime: 2022-02-25 10:48:27
-->
<template>
    <div>
        <el-container class="baimo-scrollbar bm bm-no-seleted" :style="{height: container_height+'px'}">
            <el-aside
                :style="{ width: leftWidth + 'px' }"
                class="bm-aside"
                style="overflow: hidden;"
            >
                <div class="information" style="padding: 0px;">
                    <el-tabs type="border-card">
                        <el-tab-pane label="Main">
                            <ProteinSelector v-on:proteinAccession="getProteinAccession"></ProteinSelector>
                            <raac-selector></raac-selector>
                            <SelectedRegion></SelectedRegion>
                        </el-tab-pane>
                        <el-tab-pane label="Structure">
                            <StructureSetting></StructureSetting>
                        </el-tab-pane>
                        <el-tab-pane label="Sequence">
                            <SequenceSetting></SequenceSetting>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-aside>
            <BaimocXHandle @leftWidthChange="getLeftWidthChange" />

            <el-main style="padding: 0px;">
                <PDBStructureView :height="structrueHeight + 'px'" width="100%"></PDBStructureView>
                <BaimocYHandle @heightChange="heightChange" />
                <!-- <ProteinSequenceView 
                    :height="totalHeight - structrueHeight - 120 + 'px'"
                    :width="yhandleWidth + 'px'"
                ></ProteinSequenceView> -->
            </el-main>
            <BaimocRXHandle @rightWidthChange="getRightWidthChange" />
            <el-aside
                :width="rightWidth + 'px'"
                style=" display: none;padding: 0px;background-color: #ffffff; border-left: 1px solid #cccccc;overflow: hidden;"
            >
                <!--<div style="height: 30px; color: #2F363D; background: #F6F8FA;border-top: 1px solid #E1E4E8;border-bottom: 1px solid #E1E4E8">-->
                <!--<p style="padding: 5px 0px 0px 5px; font-weight: 900">Information</p>-->
                <!--</div>-->
                <div class="information">                    
                    <el-tabs type="border-card">
                        <el-tab-pane label="Main">
                            <ProteinAnalysisMain></ProteinAnalysisMain>
                        </el-tab-pane>
                        <el-tab-pane label="Model">
                            <AlphaFold></AlphaFold>
                        </el-tab-pane>
                        <el-tab-pane label="Protein">
                            <protein></protein>
                        </el-tab-pane>
                        <el-tab-pane label="Raac">
                            <raac></raac>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-aside>
        </el-container>
        <baimo-footer :accession="accession"></baimo-footer>
    </div>
</template>

<script>
import PDBStructureView from "../../components/structure/PDBStructureView.vue";
// import ProteinSequenceView from "../../components/sequence/ProteinSequenceView.vue";
import RaacSelector from "../../components/selector/RaacSelector";
import SelectedRegion from "../../components/selector/SelectedRegion.vue";
import ProteinSelector from "../../components/selector/ProteinSelector";
import ProteinAnalysisMain from "../../components/information/ProteinAnalysisMain.vue";
import Protein from "../../components/information/Protein";
import Raac from "../../components/information/Raac";
// import ThreeSelector from "../../components/selector/ThreeSelector"
import BaimocYHandle from "../../components/BaimocYHandle";
import BaimocXHandle from "../../components/BaimocXHandle";
import BaimocRXHandle from "../../components/BaimocRXHandle";
import StructureSetting from "../../components/laside/StructureSetting";
import SequenceSetting from "../../components/laside/SequenceSetting";
import AlphaFold from "../../components/information/AlphaFold.vue";
import BaimoFooter from "../../components/BaimoFooter";

import global_ from "../../components/units/Global";
import axios from "axios";

export default {
    name: "ExpBrowser",
    data() {
        return {
            website: global_.website,
            container_height: window.innerHeight - 70,
            structrueHeight: window.innerHeight - 110,
            totalHeight: window.innerHeight - 13,
            winHeight: window.innerHeight - 52 + "px",
            winWidth: window.innerWidth - 50 + "px",
            leftWidth: 320,
            rightWidth: 360,
            yhandleWidth: window.innerWidth - 360 - 360,
            loading: true,
            dialogTableVisible: false,
            accession: "Q01860",
            jobid: "",
            selected_id: "",
        };
    },
    watch: {
        // accession(accession) {
        //     // this.getProteinInfo(accession);
        // },
    },
    components: {
        PDBStructureView,
        BaimocYHandle,
        // ProteinSequenceView,
        RaacSelector,
        ProteinSelector,
        ProteinAnalysisMain,
        Protein,
        Raac,
        BaimocXHandle,
        BaimocRXHandle,
        StructureSetting,
        AlphaFold,
        BaimoFooter,
        SequenceSetting,
        SelectedRegion,
    },
    mounted() {
        this.jobid = this.$route.params.jobid;
        this.$store.commit("sequenceMenuMutation", {
            color: [""],
            focus: false,
            leftWidth: this.leftWidth,
            multi: false,
            representation: [""],
        });
        this.$store.commit("structureResizeMutation", this.structrueHeight);
        this.getProteinAccession(this.accession);
    },
    methods: {
        getProteinAccession(val) {
            this.proteinAccession = val;
            let url = `${this.website}/api/protein_info/${val}/`;
            // console.log(url)
            axios.get(url).then((res) => {
                let info = res.data.results[0];
                // console.log("info >>> ", info)
                let pdb_url = info["pdb_url"].replace(
                    /https:\/\/alphafold.ebi.ac.uk\/files/,
                    global_.source
                );
                pdb_url
                this.$store.commit("currentProteinMutation", {
                    accession: val,
                    description: info["description"],
                    info: info["sequence"],
                    natural: info["sequence"],
                    natural_seq: info["sequence"],
                    score: info["score"],
                    pdb_url: pdb_url,
                });
            });
        },
        getAlignAccession(val) {
            this.accession = val;
            // console.log(val);
        },
        heightChange(movement) {
            this.structrueHeight -= movement;
            this.$store.commit("structureResizeMutation", this.structrueHeight);
        },
        getLeftWidthChange(movement) {
            this.leftWidth -= movement;
            this.yhandleWidth += movement;
            this.$store.commit("structureResizeMutation", this.leftWidth);
            let sequence_menu = this.$store.state.sequence_menu;
            sequence_menu["leftWidth"] = this.leftWidth;
            this.$store.commit("sequenceMenuMutation", sequence_menu);
        },
        getRightWidthChange(movement) {
            this.rightWidth += movement;
            this.$store.commit("structureResizeMutation", this.rightWidth);
        },
    },
};
</script>

<style>
.baimo-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
}

.information .el-tabs--border-card > .el-tabs__content {
    padding: 0px !important;
}

.sss {
    display: flex;
}

.el-tabs--border-card {
    border: none !important;
    box-shadow: none !important;
}

/*.el-select-dropdown__wrap .el-scrollbar__wrap {*/
/*margin-bottom: 100px !important;*/
/*}*/
/*.el-footer {*/
/*background-color: #B3C0D1;*/
/*color: #333;*/
/*text-align: center;*/
/*line-height: 60px;*/
/*}*/

.el-footer {
    background-color: #b3c0d1;
    color: #333;
    text-align: center;
    line-height: 20px;
}
</style>
